module.exports = __webpack_public_path__ + "static/media/valor1.c254a12c.png";